export default {
  menuState: {
    collapsed: true
  }
};
